<template>
  <div class="container">
    <div class="content">
      <h4 class="title is-4">Interested in how this was built?</h4>
      <p>
        This tool is built using . . . 
        <ul>
          <li>Framework:  <a href="https://v3.vuejs.org/" target="_blank">Vue 3</a></li>
          <li>Hosting:  
        <a href="https://render.com/" target="_blank">Render</a></li>
        <li>CSS:  <a href="https://bulma.io/" target="_blank">Bulma</a></li>
        <li>Charting:  <a href="https://plotly.com/javascript/" target="_blank">Plotly.js</a></li>
        </ul>
        
        I created the tool as a project to learn about Vue and hosting static
        sites.
      </p>
      <h4 class="title is-4">About</h4>
      <p>
        My name is Dan and I'm a recovered Accountant. I created this tool as a
        project to learn about Vue and hosting static sites.  You can see what I'm up to at <a href="https://thepath.dev">thepath.dev</a>.
      </p>
      <p>
        I started learning Python in 2018 as a way to automate my work. Python
        became a gateway language to JavaScript and, of course, Generative Art
        in
        <a href="https://p5js.org/" target="_blank">p5.js</a>. Despite the
        pracitcal application of machines, I believe the true purpose of all
        machines is making art (whatever art means to you).
      </p>
      <p>
        At any rate, automating my work led to automating work for co-workers.
        Helping others was great, but I wanted a way to distribute scripts so
        people could help themselves more easily. I started learning more about
        web development and, specifically,
        <a href="https://flask.palletsprojects.com/en/1.1.x/" target="_blank"
          >Flask</a
        >
        with the intention of distributing scripts. After building some projects
        using Flask and Vanilla JavaScript I decided to learn a front end
        framework. I chose Vue because it seemed simpler than other front end
        frameworks and I like simple.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "How",
  data() {
    return {};
  },
};
</script>